import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngstack/translate';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { CIDService } from 'src/app/services/common/cid.service';
import { BIDService } from 'src/app/services/common/bid.service';
import { HoldingService } from 'src/app/services/http/business/holding/holding.service';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { BranchService } from 'src/app/services/http/business/branch/branch.service';
import { ICompany } from 'src/app/interfaces/company';
import { IBranch } from 'src/app/interfaces/branch';
import { MatSelectChange, MatSelect } from '@angular/material';
//import { RegistrationReportService } from 'src/app/services/http/business/report/registration-report.service';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { ITermInfo } from 'src/app/interfaces/term-info';
import { TermInfoService } from 'src/app/services/http/business/term-info/term-info.service';
import { ILevelInfo } from 'src/app/interfaces/levelInfo';
import { IEducationPackage } from 'src/app/interfaces/educationPackage';
import { EducationPackageService } from 'src/app/services/http/business/educationPackage/education-package.service';
import { LevelInfoService } from 'src/app/services/http/business/levelInfo/level-info.service';
import * as moment from "jalali-moment";
import { CoursePatternService } from 'src/app/services/http/business/course-pattern/course-pattern.service';
import { ServiceRoute } from 'src/app/services/http/base/service-route';
import { JwtHelperService } from '@auth0/angular-jwt';
import { IParentTerm } from 'src/app/interfaces/parent-term';
import { ParrentTermService } from 'src/app/services/http/business/parrent-term/parrent-term-service.service';
import { CalendarService } from 'src/app/services/http/business/calendar/calendar.service';
import { ICalendar } from 'src/app/interfaces/calendar';
import { CourseTypeService } from 'src/app/services/http/business/course-type/course-type.service';
import { ICourseType } from 'src/app/interfaces/course-type';
import { HttpHeaders } from '@angular/common/http';
import { MarkManagementService } from 'src/app/services/http/business/markManagement/mark-management.service';
import { RoleService } from 'src/app/services/http/business/role/role.service';
import { HidService } from 'src/app/services/common/hid.service';

@Component({
  selector: 'app-education-report',
  templateUrl: './education-report.component.html',
  styleUrls: ['./education-report.component.css']
})
export class EducationReportComponent implements OnInit {

  param: any;
  errObject: any;
  errors = new Array();
  form: FormGroup;
  isOwner: boolean;
  compnayList: ICompany;
  branchList: IBranch[];
  roleList: any[];
  reportUrl: string;
  iframe: any;
  termList: ITermInfo[];
  termList2: ITermInfo[];
  TermInfo: number;
  startDateModel: string;
  endDateModel: string;
  levelInfoList: ILevelInfo[];
  yearList: ICalendar;
  parrentTermList: any;//IParentTerm[];
  parrentTermList2: IParentTerm[];
  markManagementTypeList: any;
  coursPatterns: any;
  userName: string;
  eduPackageList: IEducationPackage;
  emptyListUrl: string;
  token = localStorage.getItem("token");
  reports = [
    // {
    //   id: 1,
    //   title: 'لیست تعیین سطح های انجام شده',
    //   active: true
    // },
    // {
    //   id: 2,
    //   title: 'لیست ثبت نام های انجام شده',
    //   active: true
    // },
    // {
    //   id: 3,
    //   title: 'لیست استردادی ها',
    //   active: false
    // },
    { num: 1, id: 1, title: 'تعیین سطح های ثبت نام شده', active: true },
    { num: 2, id: 2, title: 'تعیین سطح های ثبت نام نشده', active: true },
    { num: 3, id: 3, title: 'لیست دانشجویان', active: true },
    { num: 4, id: 4, title: 'لیست ثبت نامی های جدید', active: true },
    { num: 5, id: 5, title: 'آمار ثبت نام کلیه شعب', active: true },
    { num: 6, id: 6, title: 'لیست کلاسی بر اساس الگو ', active: true },
    { num: 7, id: 26, title: 'لیست کلاسی بر اساس الگو (بدون زمان بندی)', active: true },
    { num: 8, id: 7, title: 'لیست کلاس های اساتید ', active: true },
    { num: 9, id: 8, title: 'لیست دانشجویان معلق ', active: true },
    { num: 10, id: 9, title: 'لیست دانشجویان ریزشی ', active: true },
    { num: 11, id: 10, title: 'دانشجوهای ثبت نام شده در هر شعبه ', active: true },
    { num: 12, id: 11, title: 'کلاس های ایجاد شده در شعبه ', active: true },
    { num: 13, id: 12, title: 'وضعیت نمره زبان آموزان ', active: true },
    { num: 14, id: 13, title: 'آمار زبان آموزان بر اساس سطح ', active: true },
    { num: 15, id: 14, title: 'آمار کلاس های کنسل شده ', active: true },
    { num: 16, id: 15, title: 'اطلاعات شعب و سطوح استاد ', active: true },
    { num: 17, id: 16, title: 'آمار تعیین سطح اساتید', active: true },
    { num: 18, id: 17, title: 'آمار زبان آموزان بر اساس الگو', active: true },
    { num: 19, id: 18, title: 'حضور و غیاب های ثبت نشده', active: true },
    { num: 20, id: 19, title: 'Sub اساتید', active: true },
    { num: 21, id: 20, title: 'Makeup اساتید', active: true },
    { num: 22, id: 21, title: 'پیشرفت تحصیلی پرسنل', active: true },
    { num: 23, id: 22, title: 'لیست اساتید بر اساس سطح', active: true },
    { num: 24, id: 23, title: 'تایم شیت اساتید', active: true },
    { num: 25, id: 24, title: 'زبان آموزان فارغ التحصیل', active: true },
    { num: 26, id: 25, title: 'لیست جلسات استاد', active: true },
  ];


  courseTypeList: ICourseType;

  showPackage = false;
  showMarkType = false;
  showLevel = false;
  showPattern = false;
  showTerm = false;
  showTerm2 = false;
  showTime = false;
  showYear = false;
  showYear2 = false;
  showNationalCode = false;
  showName = false;
  showTermInfo = false;
  showTermInfo2 = false;
  showEmptyBtn = false;
  showRole = false;

  constructor(
    private fb: FormBuilder,
    private hidService: HidService,
    private cidService: CIDService,
    private bidService: BIDService,
    private holdingService: HoldingService,
    private companyService: CompanyService,
    private branchService: BranchService,
    public translate: TranslateService,
    private calendarService: CalendarService,
    private parrentTermService: ParrentTermService,
    private errorService: ErrorsService,
    private courseTypeService: CourseTypeService,
    private coursPatternService: CoursePatternService,
    private termService: TermInfoService,
    private roleService: RoleService,
    private sanitizer: DomSanitizer,
    private markManagementService: MarkManagementService,
    private eduPackageService: EducationPackageService,
    private levelInfoService: LevelInfoService
  ) { }

  ngOnInit() {
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(this.token);
    this.userName = decodedToken.fname;
    this.checkOwner();
    this.createForm();
    this.getCompanyList();
    this.getEduPackage();
    this.loadYear();
    this.getMarkManagementType();
  }

  createForm() {
    this.form = this.fb.group({
      BranchEncryptId: [null],
      ReportId: [null, Validators.required],
      ParentTermId: [null],
      MarkClassificationTypeId: [null],
      ParentTermId2: [null],
      StartDate: [null],
      EndDate: [null],
      PackageId: [null],
      Year: [null],
      Year2: [null],
      TermInfoId: [null],
      RoleId: [null],
      TermInfoId2: [null],
      LevelInfoId: [null],
      CourseTypeId: [null],
      CoursePatternId: [null],
      RegistrationStatusId: [null],
      NationalCode: [null],
      FirstName: [null],
      LastName: [null]
    });
    if (this.isOwner) {
      this.form.setValue({
        BranchEncryptId: this.bidService.getBID()
      });
    }
  }

  loadYear() {
    this.calendarService.yearList().subscribe(
      res => {
        this.yearList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadCoursTypeList() {
    this.courseTypeService.list(0, 0, false, false, true).subscribe(
      res => {
        this.courseTypeList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadRole() {
    this.courseTypeService.list(0, 0, false, false, true).subscribe(
      res => {
        this.courseTypeList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getCoursPattern(e: MatSelect) {
    this.coursPatternService.getListByCourseTypeId(e.value, 0, 0).subscribe(res => {
      this.coursPatterns = res;
    },
      () => {
        this.errorService.transactionError();
      });
  }
  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
        this.bidService.setBID("");
      }
      else {
        this.loadCoursTypeList();
        //this.getParrentTermList();
      }
    });
  }

  getParrentTermList(e: MatSelect) {
    this.parrentTermService.listComboByYear(e.value).subscribe(
      res => {
        this.parrentTermList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getParrentTermList2(e: MatSelect) {
    this.parrentTermService.listComboByYear(e.value).subscribe(
      res => {
        this.parrentTermList2 = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getEduPackage() {
    this.eduPackageService.getList().subscribe(
      res => {
        this.eduPackageList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  laodLevel(element: MatSelectChange) {
    this.levelInfoService.getlistByEducationPackageId(element.value).subscribe(
      res => {
        this.levelInfoList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  setReport(e: MatSelectChange) {

    for (const key in this.form.controls) {
      if(key != 'ReportId')
      {
        this.form.get(key).clearValidators();
        this.form.get(key).updateValueAndValidity();
        this.form.get(key).reset();
      }
    }

    if(this.isOwner)
    {
      this.changeValidators('BranchEncryptId');
    }

    this.showPackage = false;
    this.showLevel = false;
    this.showPattern = false;
    this.showTerm = false;
    this.showTerm2 = false;
    this.showTime = false;
    this.showYear = false;
    this.showYear2 = false;
    this.showNationalCode = false;
    this.showName = false;
    this.showTermInfo = false;
    this.showTermInfo2 = false;
    this.showEmptyBtn = false;
    this.showRole = false;
    this.showMarkType = false;

    switch (parseInt(e.value)) {
      case 1:

        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.changeValidators('StartDate');
        this.changeValidators('EndDate');
        this.showYear = true;
        this.showTerm = true;
        this.showTime = true;
        break;
      case 2:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.changeValidators('StartDate');
        this.changeValidators('EndDate');
        this.showYear = true;
        this.showTerm = true;
        this.showTime = true;
        this.showPackage = true;
        this.showLevel = true;
        this.showPattern = true;
        break;
      case 3:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.changeValidators('StartDate');
        this.changeValidators('EndDate');
        this.showYear = true;
        this.showTerm = true;
        this.showTime = true;
        this.showPackage = true;
        this.showLevel = true;
        this.showPattern = true;
        break;
      case 4:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.showTerm = true;
        this.showYear = true;
        break;
      case 5:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.showTerm = true;
        this.showYear = true;
        break;
      case 6:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.changeValidators('CourseTypeId');
        this.changeValidators('CoursePatternId');
        
        this.showTerm = true;
        this.showYear = true;
        this.showPattern = true;
        this.showTermInfo = true;
        this.showEmptyBtn = true;
        break;
      case 26:

        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.changeValidators('CourseTypeId');
        this.changeValidators('CoursePatternId');

        this.showTerm = true;
        this.showYear = true;
        this.showPattern = true;
        this.showTermInfo = true;
        this.showEmptyBtn = true;
        break;
      case 7:

        this.changeValidators('Year');
        this.changeValidators('ParentTermId');

        this.showTerm = true;
        this.showYear = true;
        this.showNationalCode = true;
        this.showName = true;
        break;
      case 8:
        
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');

        this.showTerm = true;
        this.showTermInfo = true;
        this.showYear = true;
        break;
      case 9:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.changeValidators('Year2');
        this.changeValidators('ParentTermId2');
        this.showTerm = true;
        this.showTerm2 = true;
        this.showYear = true;
        this.showYear2 = true;
        break;
      case 10:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.showPackage = true;
        this.showTerm = true;
        this.showYear = true;
        break;
      case 11:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.showPackage = true;
        this.showTerm = true;
        this.showYear = true;
        break;
      case 12:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.changeValidators('MarkClassificationTypeId');
        
        this.showTerm = true;
        this.showYear = true;
        this.showTermInfo = true;
        this.showLevel = true;
        this.showPackage = true;
        this.showMarkType = true;
        break;
      case 13:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.showTerm = true;
        this.showYear = true;
        this.showTermInfo = true;
        this.showLevel = true;
        this.showPackage = true;
        break;
      case 14:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.showTerm = true;
        this.showYear = true;
        this.showTime = true;
        break;
      case 15:
        this.changeValidators('NationalCode');
        
        this.showNationalCode = true;
        break;
      case 16:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.showTerm = true;
        this.showYear = true;
        this.showTime = true;
        break;
      case 17:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.showTerm = true;
        this.showYear = true;
        this.showTermInfo = true;
        this.showLevel = true;
        this.showPackage = true;
        break;
      case 18:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.showTerm = true;
        this.showYear = true;
        this.showTime = true;
        break;
      case 19:
        this.changeValidators('StartDate');
        this.changeValidators('EndDate');
        this.showNationalCode = true;
        this.showTime = true;
        break;
      case 20:
        this.changeValidators('StartDate');
        this.changeValidators('EndDate');
        this.showNationalCode = true;
        this.showTime = true;
        break;
      case 21:
        this.changeValidators('RoleId');
        this.showNationalCode = true;
        this.showName = true;
        this.showRole = true;
        break;
      case 22:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.showPackage = true;
        this.showLevel = true;
        this.showYear = true;
        this.showTerm = true;
        this.showTermInfo = true;
        break;
      case 23:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.showTerm = true;
        this.showYear = true;
        this.showNationalCode = true;
        break;
      case 24:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.showTerm = true;
        this.showTermInfo = true;
        this.showPackage = true;
        this.showLevel = true;
        this.showPattern = true;
        this.showYear = true;
        break;
      case 25:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.showYear = true;
        this.showTerm = true;
        this.showName = true;
        this.showNationalCode = true;
        this.showTime = true;
        break;
    }
  }

  changeValidators(key: string) {
    this.form.controls[key].setValidators(Validators.required);
    this.form.controls[key].updateValueAndValidity();
  }

  setCid(e: MatSelectChange) {
    if (this.isOwner) {
      this.cidService.setCID(e.value);
      this.bidService.removeBID();
      this.loadCoursTypeList();
    }
    this.getBranchList(e.value);
    //this.getParrentTermList();
    this.getRoleList(e.value);
    this.form.get('BranchEncryptId').setValue(null);
  }

  getMarkManagementType() {
    this.markManagementService.typeComboList().subscribe(res => {
      this.markManagementTypeList = res;
    })
  }

  setBid(e: MatSelect) {
    if (this.isOwner)
      this.bidService.setBID(e.value);
  }

  setDate(e: MatSelect) {
    // var year = moment
    //   .from(new Date().toDateString(), "en")
    //   .utc(true)
    //   .format('jYYYY');
    var parentTerm = this.parrentTermList.find(function (element) {
      return element.Id == e.value;
    });

    this.startDateModel = parentTerm.StartDate;// moment.from(year + '/' + parentTerm.MonthAndDayStart, 'fa', 'YYYY/MM/DD').format('YYYY/MM/DD')
    this.endDateModel = parentTerm.EndDate;// moment.from(year + '/' + parentTerm.MonthAndDayEnd, 'fa', 'YYYY/MM/DD').format('YYYY/MM/DD')
    this.termService.getListById(e.value, 0, 0).subscribe(res => {
      this.termList = res.DataList;
    });
  }

  setDate2(e: MatSelect) {

    this.termService.getListById(e.value, 0, 0).subscribe(res => {
      this.termList2 = res.DataList;
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.compnayList = res.DataList;
    });
  }

  getBranchList(company) {
    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );
    this.branchService.listByCompanyHeader(0, 0, headers).subscribe(
      res => {
        this.branchList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getRoleList(company) {
    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );
    this.roleService.fullList(0, 0, headers).subscribe(
      res => {
        this.roleList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getEmptyListUrl(data: any) {
    return environment.ReportBaseUrl + ServiceRoute.report.education.GetCorseByEmptyShow +
      '?CompanyId=' + this.cidService.getCID() +
      '&UserName=' + this.userName +
      '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
  }
  submit(data: any) {
    data.StartDate = moment
      .from(data.StartDate, "en")
      .utc(true)
      .format(environment.dateFormat);

    data.EndDate = moment
      .from(data.EndDate, "en")
      .utc(true)
      .format(environment.dateFormat);
    var url = '';
    switch (parseInt(data.ReportId)) {
      case 1:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetPlacmectRegistredShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&ParentTermId=' + data.ParentTermId +
          '&StartDate=' + data.StartDate +
          '&EndDate=' + data.EndDate +
          '&UserName=' + this.userName +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 2:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetPlacmectNotRegistredShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&ParentTermId=' + data.ParentTermId +
          '&StartDate=' + data.StartDate +
          '&EndDate=' + data.EndDate +
          '&UserName=' + this.userName +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 3:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetStudentsShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&ParentTermId=' + data.ParentTermId +
          '&StartDate=' + data.StartDate +
          '&EndDate=' + data.EndDate +
          '&UserName=' + this.userName +
          '&PackageId=' + data.PackageId +
          '&CourseTypeId=' + data.CourseTypeId +
          '&CoursePatternId=' + data.CoursePatternId +
          '&LevelInfoId=' + data.LevelInfoId +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;

      case 4:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetNewStudentRegistrationShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&ParentTermId=' + data.ParentTermId +
          '&Year=' + data.Year +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 5:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.CountRegisterationShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&ParentTermId=' + data.ParentTermId +
          '&UserName=' + this.userName +
          '&Year=' + data.Year +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 6:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetCorseByPatternShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&ParentTermId=' + data.ParentTermId +
          '&TermInfoId=' + data.TermInfoId +
          '&UserName=' + this.userName +
          '&Year=' + data.Year +
          '&CoursePatternId=' + data.CoursePatternId +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 26:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetCorseByPatternWithoutTimeShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&ParentTermId=' + data.ParentTermId +
          '&TermInfoId=' + data.TermInfoId +
          '&UserName=' + this.userName +
          '&Year=' + data.Year +
          '&CoursePatternId=' + data.CoursePatternId +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 7:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.TeacherCourseShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&ParentTermId=' + data.ParentTermId +
          '&UserName=' + this.userName +
          '&Year=' + data.Year +
          '&NationalCode=' + data.NationalCode +
          '&FirstName=' + data.FirstName +
          '&LastName=' + data.LastName +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 8:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetSuspendedStudentShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&UserName=' + this.userName +
          '&Year=' + data.Year +
          '&ParentTermId=' + data.ParentTermId +
          '&TermInfoId=' + data.TermInfoId +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 9:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetStudentFallShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&UserName=' + this.userName +
          '&Year=' + data.Year +
          '&Year2=' + data.Year2 +
          '&ParentTermId=' + data.ParentTermId +
          '&ParentTermId2=' + data.ParentTermId2 +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 10:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.RegistrationBranchShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&UserName=' + this.userName +
          '&Year=' + data.Year +
          '&ParentTermId=' + data.ParentTermId +
          '&PackageId=' + data.PackageId +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 11:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.CourseBranchShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&UserName=' + this.userName +
          '&Year=' + data.Year +
          '&ParentTermId=' + data.ParentTermId +
          '&PackageId=' + data.PackageId +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 12:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetMarkStsShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&UserName=' + this.userName +
          '&Year=' + data.Year +
          '&ParentTermId=' + data.ParentTermId +
          '&TermInfoId=' + data.TermInfoId +
          '&PackageId=' + data.PackageId +
          '&LevelInfoId=' + data.LevelInfoId +
          '&MarkClassificationTypeId=' + data.MarkClassificationTypeId +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 13:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetEduCountLevelStsShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&UserName=' + this.userName +
          '&Year=' + data.Year +
          '&ParentTermId=' + data.ParentTermId +
          '&TermInfoId=' + data.TermInfoId +
          '&PackageId=' + data.PackageId +
          '&LevelInfoId=' + data.LevelInfoId +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 14:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetCourseCancelShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&UserName=' + this.userName +
          '&ParentTermId=' + data.ParentTermId +
          '&StartDate=' + data.StartDate +
          '&EndDate=' + data.EndDate +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 15:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetContractBranchPackegeShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&UserName=' + this.userName +
          '&NationalCode=' + data.NationalCode;
        break;
      case 16:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetTeachersPlacmentShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&UserName=' + this.userName +
          '&ParentTermId=' + data.ParentTermId +
          '&StartDate=' + data.StartDate +
          '&EndDate=' + data.EndDate +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 17:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetEduCountPatternStsShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&UserName=' + this.userName +
          '&Year=' + data.Year +
          '&ParentTermId=' + data.ParentTermId +
          '&TermInfoId=' + data.TermInfoId +
          '&PackageId=' + data.PackageId +
          '&LevelInfoId=' + data.LevelInfoId +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 18:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetEduSessionNotCheckoutShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&UserName=' + this.userName +
          '&ParentTermId=' + data.ParentTermId +
          '&StartDate=' + data.StartDate +
          '&EndDate=' + data.EndDate +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 19:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetEduTeachereSessionSubShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&UserName=' + this.userName +
          '&NationalCode=' + data.NationalCode +
          '&StartDate=' + data.StartDate +
          '&EndDate=' + data.EndDate +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 20:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetEduTeachereMackupSessionShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&UserName=' + this.userName +
          '&NationalCode=' + data.NationalCode +
          '&StartDate=' + data.StartDate +
          '&EndDate=' + data.EndDate +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 21:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetEmployeeAcademicAchievementShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&UserName=' + this.userName +
          '&NationalCode=' + data.NationalCode +
          '&FirstName=' + data.FirstName +
          '&LastName=' + data.LastName +
          '&RoleId=' + data.RoleId +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 22:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetTeacherLevelShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&UserName=' + this.userName +
          '&Year=' + data.Year +
          '&ParentTermId=' + data.ParentTermId +
          '&TermInfoId=' + data.TermInfoId +
          '&PackageId=' + data.PackageId +
          '&LevelInfoId=' + data.LevelInfoId +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 23:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetTeacherTimeSheetShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&UserName=' + this.userName +
          '&Year=' + data.Year +
          '&ParentTermId=' + data.ParentTermId +
          '&NationalCode=' + data.NationalCode +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 24:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetGraduatedStudentShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&UserName=' + this.userName +
          '&Year=' + data.Year +
          '&ParentTermId=' + data.ParentTermId +
          '&TermInfoId=' + data.TermInfoId +
          '&PackageId=' + data.PackageId +
          '&LevelInfoId=' + data.LevelInfoId +
          '&CoursePatternId=' + data.CoursePatternId +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;

      case 25:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetSessionShow +
          '?HoldingId=' + this.hidService.getHID() +
          '&CompanyId=' + this.cidService.getCID() +
          '&UserName=' + this.userName +
          '&Year=' + data.Year +
          '&ParentTermId=' + data.ParentTermId +
          '&StartDate=' + data.StartDate +
          '&EndDate=' + data.EndDate +
          '&NationalCode=' + data.NationalCode +
          '&FirstName=' + data.FirstName +
          '&LastName=' + data.LastName;
        break;

    }
    this.iframe = this.sanitizer.bypassSecurityTrustResourceUrl(url.split("null").join(""));
  }
}

